import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HomePageLink = styled(Link)`
  text-decoration: none;
`;
